document.addEventListener('DOMContentLoaded', function() {
    app();
});

window.addEventListener('resize', function () {
    initHeader();
});

function app() {
    //console.log('hilltop app started');
    if (!isMobileDevice()) {
        initHeader();
    }
}

function getScreenWidth() {
    let d=document,
        e=d.documentElement,
        g=d.getElementsByTagName('body')[0];

    return window.innerWidth||e.clientWidth||g.clientWidth;
}

function isMobileDevice() {
    return getScreenWidth() <= 1399;
}

function initHeader() {
    let $headerContent = document.getElementById('pageHeaderContent');
    let $headerImage   = document.querySelector('.page-header__image');
    let $headerTitle   = document.querySelector('.page-header__content__title');

    if ($headerContent && $headerContent.classList.contains('has-footer') && $headerImage) {
        $headerContent.style.height = `${$headerImage.clientHeight}px`;

        $headerImage.addEventListener('load', function() {
            $headerContent.style.height = `${$headerImage.clientHeight}px`;
            $headerTitle ? $headerTitle.style.opacity = '1' : '';
        });
    } else {
        $headerTitle ? $headerTitle.style.opacity = '1' : '';
    }
}
